import { beforeEarliestBusinessDateMessage, EARLIEST_BUSINESS_DATE, } from '../zod-helpers/earliest-business-date.js';
import { localDateInput } from '../zod-helpers/local-date-input.js';
/** A credit's issued or expiration day: a real `YYYY-MM-DD` from 1900 on, out as UTC midnight. */
export const creditDateInput = (label) => localDateInput(`${label} must be a valid date.`, {
    earliest: EARLIEST_BUSINESS_DATE,
    earliestMessage: beforeEarliestBusinessDateMessage(label),
});
//# sourceMappingURL=credit-date-input.js.map